import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats time from "hh:mm:ss" format to "hh:mm" format
 * @param time - Time string in "hh:mm:ss" format
 * @returns Time string in "hh:mm" format
 */
export function formatTime(time: string): string {
  if (!time) return ''
  
  // Split by colon and take only the first two parts (hours and minutes)
  const parts = time.split(':')
  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]}`
  }
  
  return time
}
